import React, { useState, useImperativeHandle, forwardRef } from 'react'
import ReactDOM from 'react-dom'
import { trans } from '../../../../../_providers/Translation'

import loader from '../../../../../assets/img/loader.svg'

function EditComment(props, ref) {
    const [state, setState] = useState({
        overlay: false,
        modal: false,
        data: {},
        loadingButtons: false,
    })

    useImperativeHandle(ref, () => ({
        open: (data) => {
            setState(prev => ({ ...prev, overlay: true, data }))
            setTimeout(() => setState(prev => ({ ...prev, modal: true })), 50)
        },
        close: () => handleCancel(),
    }))

    const handleCancel = e => {
        if (e) e.preventDefault()
        setState(prev => ({ ...prev, modal: false }))
        setTimeout(() => setState(prev => ({ ...prev, overlay: false, data: {} })), 50)
    }

    const handleSend = e => {
        e.preventDefault()
        props.handleUpdate(e)
        handleCancel()
    }

    return ReactDOM.createPortal(
        <form className={`${state.overlay ? 'visible' : ''} overlay`} onSubmit={handleSend}>
            <div className={`${state.modal ? 'show' : ''} popup-primary large`}>
                <div className="head-new">
                    <div className="texts">
                        <h2>{trans('headings.editComment')}</h2>
                        <p>{trans('subheadings.editComment')}</p>
                    </div>
                    <span className="close" onClick={handleCancel} />
                </div>
                <div className="popup-container-read-only">
                    <div className="col">
                        <label>{trans('labels.comments')}</label>
                        <textarea
                            name="comment"
                            key={state.data.id}
                            defaultValue={state.data.comment}
                        />
                        <input type="hidden" name="id" value={state.data.id || ''} />
                    </div>
                </div>
                <div className="footer align-right">
                    {state.loadingButtons
                        ? <img src={loader} alt="loading" />
                        : <>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.edit')}
                            </button>
                            <button type="button" onClick={handleCancel}>
                                {trans('buttons.cancel')}
                            </button>
                        </>
                    }
                </div>
            </div>
        </form>,
        document.body
    )
}

export default forwardRef(EditComment)
